import { cn } from '@/utils/cn';

const ordinal = (n: number) => {
  const mod100 = n % 100;

  if (mod100 >= 11 && mod100 <= 13) {
    return `${n}th`;
  }

  const suffix = ['th', 'st', 'nd', 'rd'][n % 10] ?? 'th';

  return `${n}${suffix}`;
};

const SIZES = {
  display: 'text-[12vh] text-slate-500',
  overlay: 'text-lg uppercase',
  control: 'text-gray-500',
} as const;

export const PeriodLabel = ({
  current,
  total,
  label,
  variant,
}: {
  current: number;
  total: number;
  label: string;
  variant: keyof typeof SIZES;
}) => {
  const text =
    label === 'Set'
      ? `Set ${current} of ${total}`
      : `${ordinal(current)} ${label}`;

  return (
    <div className={cn('text-center leading-none', SIZES[variant])}>{text}</div>
  );
};
